<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 resellerInvoice-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("RESELLER_INVOICES.EDIT_RESELLER_INVOICE") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <resellerInvoice-form
              :loading="loading"
              :resellerInvoiceData="resellerInvoice"
              :formErrors="formErrors"
              @resellerInvoiceSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import ResellerInvoiceForm from "./partials/ResellerInvoiceForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultResellerInvoice from "./defaultResellerInvoice";

export default {
  layout: "DashboardLayout",

  components: { ResellerInvoiceForm },

  mixins: [alertLeave],

  data() {
    return {
      resellerInvoice: cloneDeep(defaultResellerInvoice),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("resellerInvoices/get", id);
        this.resellerInvoice =
          this.$store.getters["resellerInvoices/resellerInvoice"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List ResellerInvoices" });
    },

    viewResellerInvoice() {
      this.alertLeave = false;
      this.$router.push({
        name: "View ResellerInvoice",
        params: { id: this.resellerInvoice.id },
      });
    },

    async handleSubmit(resellerInvoice) {
      this.loading = true;
      const resellerInvoiceData = cloneDeep(resellerInvoice);
      try {
        await this.$store.dispatch(
          "resellerInvoices/update",
          resellerInvoiceData
        );
        this.$notify({
          type: "success",
          message: this.$t("RESELLER_INVOICES.RESELLER_INVOICE_UPDATED"),
        });
        this.viewResellerInvoice();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
